<template>
    <span :class="className">{{ orderStatusName }}</span>
</template>

<script>
export default {
    name: "OrderStatusText",

    data () {
        return {
            //TODO: complete classes
            classNames: [
                "warning--text",
                "success--text",
            ],
        };
    },

    props: {
        orderStatus: Number,
        orderStatusName: String
    },

    computed: {
        className() {
            return this.classNames[this.orderStatus] ?? null;
        },
    }
}
</script>

<style scoped>

</style>
